import useAxios from 'hooks/useAxios';

export async function getAffiliateCodeById(id) {
  const api = useAxios();

  try {
    const res = await api.get(`/users/affiliate-codes/${id}`);
    return res;
  } catch (err) {
    return err;
  }
}

